import { render } from "./ClozeList.vue?vue&type=template&id=a9829afa&scoped=true"
import script from "./ClozeList.vue?vue&type=script&lang=js"
export * from "./ClozeList.vue?vue&type=script&lang=js"

import "./ClozeList.vue?vue&type=style&index=0&id=a9829afa&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9829afa"]])

export default __exports__